/** @param {string} x */
const trimSlashes = (x) => x.toString().replace(/^\/+|\/+$/g, '');

const appendPath = (apiPath) => (...args) =>  [apiPath, ...args].map(trimSlashes).join('/');

/**
 * ex.: {a: 1, b: "one"} returns "?a=1&b=one"
 * @param {Object=} object
 * @returns {string}
 */
export const toQueryString = (object) => {
    if (!object) {
        return '';
    }

    const str = [];
    for (const p in object) {
        if (Object.prototype.hasOwnProperty.call(object, p)) {
            if (Array.isArray(object[p])) {
                str.push(new URLSearchParams(object[p].map((i) => [encodeURIComponent(p), encodeURIComponent(i)])).toString());
            } else {
                str.push(`${encodeURIComponent(p)}=${encodeURIComponent(object[p])}`);
            }
        }
    }
    return `?${str.join('&')}`;
};

export default appendPath;
